import React, { useState, useRef, useEffect } from 'react';
import { Icone } from 'vivace-fluent-motion';
import PreviewBase from '@containers/previewBase';
import WebapiCommon from '@common/util/webapi.common';
import * as Actions from '@containers/BaseConhecimento/store/base.action';
import { useSelector, useDispatch } from 'react-redux';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Input, Row, Button, FormGroup, Col, Label } from 'reactstrap';
import SelectComponent from '@componentes/select/select.component';
import MultiRange from '@componentes/ranger';
import { Colxx } from '@common/customBootstrap';
import { getDate } from '../../functions/general';
import './style.css';
import { injectIntl } from 'react-intl';
import IntlMessage from "../../helpers/intlMessage";

const BaseConhecimento = ({ intl }) => {

  const [input, setInput] = useState('');
  const [laudos, setLaudos] = useState(null);
  const [isLoading, setIsloading] = useState(false);
  const page = useSelector((state) => state.baseConhecimento.page);
  const filter = useSelector((state) => state.baseConhecimento.filter);
  const [total, setTotal] = useState(0);
  const [selectUnidades, setSelectUnidades] = useState([]);
  const [periodo, setPeriodo] = useState({});
  const [selectPeriodos, setSelectPeriodos] = useState([]);
  const { messages } = intl;

  const overlayResultados = useRef(null);
  const overlayFiltros = useRef(null);
  const isMonted = useRef(null);
  const dispatch = useDispatch();

  const periodos = [
    { value: 'hoje', label: <IntlMessage id="dashboards.general.today" /> },
    { value: 'ontem', label: <IntlMessage id="dashboards.general.yesterday" /> },
    { value: 'anteontem', label: <IntlMessage id="dashboards.general.beforeYesterday" /> },
    { value: 'semana', label: <IntlMessage id="dashboards.general.oneWeekAgo" /> },
    { value: 'quinzena', label: <IntlMessage id="dashboards.general.fifteenDaysAgo" /> },
    { value: 'mes', label: <IntlMessage id="dashboards.general.aMonthAgo" /> },
    { value: 'doisMeses', label: <IntlMessage id="dashboards.general.twoMonthsAgo" /> },
    { value: 'tresMeses', label: <IntlMessage id="dashboards.general.threeMonthsAgo" /> },
    { value: 'seisMeses', label: <IntlMessage id="dashboards.general.sixMonthsAgo" /> },
    { value: 'ano', label: <IntlMessage id="dashboards.general.aYearAgo" /> },
    { value: 'outro', label: <IntlMessage id="dashboards.general.other" /> },
  ];

  const initFilter = {
    laudo: '',
    nrexame: '',
    comentario: '',
    paciente: '',
    unidades: [],
    procedimento: '',
    dataInicio: '',
    dataFim: '',
    idadeInicio: 0,
    idadeFim: 120,
    prontuario: '',
  };

  useEffect(() => {
    setSelectPeriodos(periodos);
    WebapiCommon.unidadeAtendimento().then((res) => {
      setSelectUnidades(res.data);
    });
  }, []);

  useEffect(() => {
    if (isMonted.current) {
      getLaudos();
    }
    isMonted.current = true;
  }, [page]);

  function periodoChanged(e) {
    const customPeriodo = e.value;
    const payload = getDate(customPeriodo);

    onDate(payload);
    setPeriodo(periodos.find((x) => x.value === customPeriodo));
  }

  function clearFilter() {
    dispatch(Actions.filter(initFilter));
    setInput('');
    setPeriodo({});
  }

  const onChange = (e) => {
    const userInput = e.target.value;
    setInput(userInput);
  };

  const onDate = (payload) => {
    let _filter = { ...filter };
    _filter["dataInicio"] = new Date(payload.dtinicial).toISOString().slice(0, 10);
    _filter["dataFim"] = new Date(payload.dtfinal).toISOString().slice(0, 10);
    dispatch(Actions.filter(_filter));
  };

  const onFilter = (label, value) => {
    let _filter = { ...filter };
    _filter[label] = value;
    dispatch(Actions.filter(_filter));
  };

  const onKeyDown = (event) => {
    overlayResultados.current.hide();
    if (event.keyCode === 13) {
      dispatch(Actions.page('1'));
    }
  };

  async function getLaudos() {
    setLaudos([]);
    setTotal(0);
    setIsloading(true);
    await WebapiCommon.baseConhecimento(input, page, filter)
      .then((res) => {
        setLaudos(res.data);
        setTotal(Math.round(res.totalItems));
        setIsloading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsloading(false);
      });
  }

  return (

    <div className="autocomplete">
      <form id="form-base" onSubmit={(e) => {
        e.preventDefault();
        dispatch(Actions.page(1));
        overlayResultados.current.toggle(overlayResultados.current);
        overlayFiltros.current.hide();
        getLaudos();
      }}>
        <div className="input-group">
          <Input
            // required="required"
            minLength="3"
            type="text"
            className="form-control busca-baseconhecimento"
            placeholder={messages['dashboards.general.knowledgeBase']}
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={input}
          />
          <div className="filtro input-append">
            <Button type="button">
              <Icone
                iconColorOnHover={'black'}
                style={{ marginTop: 0 }}
                icone={'mv-basico-filtro'}
                onClick={(e) => {
                  overlayFiltros.current.toggle(e);
                  overlayResultados.current.hide();
                }}
              ></Icone>
            </Button>
          </div>
          <div className="baseconhecimento input-append">
            <Button type="submit">
              <Icone
                iconColorOnHover={'black'}
                style={{ marginTop: 0 }}
                icone={'mv-basico-pesquisar'}
              ></Icone>
            </Button>
          </div>
        </div>
      </form>

      <OverlayPanel
        ref={overlayFiltros}
        showCloseIcon={false}
        dismissable={false}
        id="overlay_panel"
        style={{
          width: '650px',
          maxHeight: '90vh',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        className="overlaypanel"
      >
        <form onSubmit={(e) => {
          e.preventDefault();
          getLaudos();
          overlayFiltros.current.hide();
          overlayResultados.current.toggle(overlayResultados.current);
        }}>
          <Row>
            <Colxx xl={6}>
              <FormGroup>
                <Label><IntlMessage id="dashboards.examDetails.term" /></Label>
                <Input
                  required={!filter.comentario}
                  minLength="3"
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                />
              </FormGroup>
            </Colxx>
            <Colxx xl={6}>
              <FormGroup>
                <Label><IntlMessage id="dashboards.examDetails.laud" /></Label>
                <Input
                  type="text"
                  value={filter.laudo}
                  onChange={(e) => onFilter('laudo', e.target.value)}
                />
              </FormGroup>
            </Colxx>
            <Colxx xl={6}>
              <FormGroup>
                <Label><IntlMessage id="dashboards.examDetail.numberOfExam" /></Label>
                <Input
                  type="text"
                  value={filter.nrexame}
                  onChange={(e) => onFilter('nrexame', e.target.value)}
                />
              </FormGroup>
            </Colxx>
            <Colxx xl={6}>
              <FormGroup>
                <Label><IntlMessage id="dashboards.examDetail.patient" /></Label>
                <Input
                  type="text"
                  value={filter.paciente}
                  onChange={(e) => onFilter('paciente', e.target.value)}
                />
              </FormGroup>
            </Colxx>
            <Colxx xl={12}>
              <FormGroup>
                <Label><IntlMessage id="dashboards.reports.comment" /></Label>
                <Input
                  type="textarea"
                  value={filter.comentario}
                  onChange={(e) => onFilter('comentario', e.target.value)}
                />
              </FormGroup>
            </Colxx>
          </Row>
          <Row>
            <Colxx xl={6}>
              <FormGroup>
                <Label><IntlMessage id="dashboards.examDetails.unitys" /></Label>
                <SelectComponent
                  isMulti
                  options={selectUnidades}
                  value={filter.unidades}
                  onChange={(e) => onFilter('unidades', e)}
                />
              </FormGroup>
            </Colxx>
            <Colxx xl={6}>
              <FormGroup>
                <Label><IntlMessage id="dashboards.examDetails.periods" /></Label>
                <SelectComponent
                  options={selectPeriodos}
                  value={periodo}
                  onChange={(e) => periodoChanged(e)}
                />
              </FormGroup>
            </Colxx>
          </Row>
          {periodo && periodo.value === 'outro' && (
            <Row>
              <React.Fragment>
                <Colxx xl={6}>
                  <FormGroup>
                    <Label><IntlMessage id="dashboards.graphics.initial" /></Label>
                    <Input
                      debounceTimeout={900}
                      onChange={(e) => onFilter('dataInicio', e.target.value)}
                      type="date"
                      value={filter.dataInicio}
                      max={filter.dataFim}
                      style={{ width: 'unset', maxWidth: 'unset' }}
                    />
                  </FormGroup>
                </Colxx>
                <Colxx xl={6}>
                  <FormGroup>
                    <Label><IntlMessage id="dashboards.graphics.last" /></Label>
                    <Input
                      debounceTimeout={900}
                      onChange={(e) => onFilter('dataFim', e.target.value)}
                      type="date"
                      value={filter.dataFim}
                      min={filter.dataInicio}
                      style={{ width: 'unset' }}
                    />
                  </FormGroup>
                </Colxx>
              </React.Fragment>
            </Row>
          )}
          <Row>
            <div className="col-12">
              <Label><IntlMessage id="dashboards.examDetails.yearsOld" /></Label>
            </div>
            <div className="col-3">
            </div>

            <div className="col-8 mb-3">
              <MultiRange
                step={0.5}
                min={0}
                max={120}
                values={[filter.idadeInicio, filter.idadeFim]}
                onValues={(e) => {
                  let _filter = { ...filter };
                  _filter['idadeInicio'] = e[0];
                  _filter['idadeFim'] = e[1];
                  dispatch(Actions.filter(_filter));
                }}
              />
            </div>

          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Button
                  color="primary"
                  block
                  type="submit"
                >
                  <IntlMessage id="dashboards.cytology.search" />
                </Button>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Button color="secondary" block onClick={() => clearFilter()}>
                  <IntlMessage id="dashboards.examDetails.reset" />
                </Button>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Button
                  color="light"
                  block
                  onClick={() => {
                    overlayFiltros.current.toggle(overlayFiltros.current);
                  }
                  }
                >
                  <IntlMessage id="general.materialArchiving.close" />
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </form>
      </OverlayPanel>
      <PreviewBase
        loading={isLoading}
        total={total}
        page={page}
        laudos={laudos}
        text={input}
        op={overlayResultados}
        onRef={(e) => (overlayResultados.current = e)}
      />
    </div>
  );
}
export default injectIntl(BaseConhecimento);



// WEBPACK FOOTER //
// ./src/containers/BaseConhecimento/index.js